import React, { useCallback, useState } from 'react';
import * as Styles from './SideContent.styles';
import {
  IconArrowCollapse,
  IconClose,
  IconEllipsis,
  IconMiniminize,
  Tooltip,
} from 'gatorcomponents';
import { useDispatch } from 'react-redux';
import { merlinActions } from '@/redux/modules';
import { SettingsPopover } from '../SettingsPopover';
import { useResize } from '@/hooks/useResize';

const SideContent = ({
  url,
  closeSideContent,
  closeChat,
  toggleFullScreen,
  isOpen = false,
  locales,
}) => {
  const [showSettings, setShowSettings] = useState(false);
  const dispatch = useDispatch();

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  const handleCloseSideContent = useCallback(() => {
    closeSideContent && closeSideContent();
  }, [closeSideContent]);

  const handleToggleFullScreen = useCallback(() => {
    dispatch(merlinActions.inhouse.resetSideContent());
    toggleFullScreen && toggleFullScreen();
  }, [toggleFullScreen, dispatch]);

  const handleClose = useCallback(() => {
    if (isMobile) {
      return dispatch(merlinActions.inhouse.resetSideContent());
    }
    closeChat && closeChat({ withTimout: false });
  }, [closeChat, dispatch, isMobile]);

  const handleToggleSettings = useCallback(() => {
    setShowSettings(prev => !prev);
  }, []);

  if (!isOpen || !url) {
    return null;
  }

  return (
    <Styles.Container data-testid="chat-side-content">
      <Styles.Toolbar>
        <Tooltip content={locales.tooltips.closeDocument}>
          <Styles.ToolbarButton onClick={handleCloseSideContent} $hideInMobile data-testid="close-side-content">
            <IconArrowCollapse direction="left" size="sm" color="lowDark" />
          </Styles.ToolbarButton>
        </Tooltip>

        <Styles.ChatActions>
          <Tooltip content={locales.tooltips.shrink}>
            <Styles.ToolbarButton
              onClick={handleToggleFullScreen}
              $hideInMobile
              data-testid="toggle-full-screen"
            >
              <IconMiniminize size="sm" color="lowDark" />
            </Styles.ToolbarButton>
          </Tooltip>

          <Tooltip content={locales.tooltips.settings}>
            <Styles.ToolbarButton onClick={handleToggleSettings} $hideInMobile data-testid="toggle-settings">
              <IconEllipsis color="lowDark" />
            </Styles.ToolbarButton>
          </Tooltip>

          <Tooltip content={locales.tooltips.close}>
            <Styles.ToolbarButton onClick={handleClose} data-testid="close-chat">
              <IconClose color="lowDark" />
            </Styles.ToolbarButton>
          </Tooltip>
        </Styles.ChatActions>
      </Styles.Toolbar>
      {showSettings && (
        <SettingsPopover
          label={locales.showMaiaOnInit}
          privacyPolicy={locales.privacyPolicy}
          termsOfUse={locales.termsOfUse}
          onClose={() => setShowSettings(false)}
          isFullScreen
        />
      )}

      <Styles.ContentArea>
        <Styles.Iframe data-testid="side-content-iframe" src={url} allow="fullscreen" />
      </Styles.ContentArea>
    </Styles.Container>
  );
};

export default SideContent;
